/**
  DO NOT EDIT THIS FILE MANUALLY
  Generated by `Opus::Mkt::Tools::GenerateReactData`
  If this file is out-of-sync or causing builds to fail, try running `scripts/bin/remote-script ./mkt/Tools/generate_react_data.rb`
*/

import {Locales} from 'mkt-ssr/generated/globalization/locales';
import {Countries} from 'mkt-ssr/generated/globalization/countries';

export const PathPrefixes = {
  us: {
    prefix: 'us',
    country: Countries.US,
    locale: Locales.enUs,
    hreflang: 'en-US',
  },
  'es-us': {
    prefix: 'es-us',
    country: Countries.US,
    locale: Locales.es419,
    hreflang: 'es-US',
  },
  'zh-us': {
    prefix: 'zh-us',
    country: Countries.US,
    locale: Locales.zhHans,
    hreflang: 'zh-US',
  },
  ae: {
    prefix: 'ae',
    country: Countries.AE,
    locale: Locales.enUs,
    hreflang: 'en-AE',
  },
  at: {
    prefix: 'at',
    country: Countries.AT,
    locale: Locales.deDe,
    hreflang: 'de-AT',
  },
  'en-at': {
    prefix: 'en-at',
    country: Countries.AT,
    locale: Locales.enGb,
    hreflang: 'en-AT',
  },
  au: {
    prefix: 'au',
    country: Countries.AU,
    locale: Locales.enGb,
    hreflang: 'en-AU',
  },
  'nl-be': {
    prefix: 'nl-be',
    country: Countries.BE,
    locale: Locales.nlNl,
    hreflang: 'nl-BE',
  },
  'fr-be': {
    prefix: 'fr-be',
    country: Countries.BE,
    locale: Locales.frFr,
    hreflang: 'fr-BE',
  },
  'de-be': {
    prefix: 'de-be',
    country: Countries.BE,
    locale: Locales.deDe,
    hreflang: 'de-BE',
  },
  'en-be': {
    prefix: 'en-be',
    country: Countries.BE,
    locale: Locales.enGb,
    hreflang: 'en-BE',
  },
  'en-bg': {
    prefix: 'en-bg',
    country: Countries.BG,
    locale: Locales.enGb,
    hreflang: 'en-BG',
  },
  br: {
    prefix: 'br',
    country: Countries.BR,
    locale: Locales.ptBr,
    hreflang: 'pt-BR',
  },
  'en-br': {
    prefix: 'en-br',
    country: Countries.BR,
    locale: Locales.enUs,
    hreflang: 'en-BR',
  },
  'en-ca': {
    prefix: 'en-ca',
    country: Countries.CA,
    locale: Locales.enGb,
    hreflang: 'en-CA',
  },
  'fr-ca': {
    prefix: 'fr-ca',
    country: Countries.CA,
    locale: Locales.frCa,
    hreflang: 'fr-CA',
  },
  'de-ch': {
    prefix: 'de-ch',
    country: Countries.CH,
    locale: Locales.deDe,
    hreflang: 'de-CH',
  },
  'fr-ch': {
    prefix: 'fr-ch',
    country: Countries.CH,
    locale: Locales.frFr,
    hreflang: 'fr-CH',
  },
  'it-ch': {
    prefix: 'it-ch',
    country: Countries.CH,
    locale: Locales.itIt,
    hreflang: 'it-CH',
  },
  'en-ch': {
    prefix: 'en-ch',
    country: Countries.CH,
    locale: Locales.enGb,
    hreflang: 'en-CH',
  },
  'en-cy': {
    prefix: 'en-cy',
    country: Countries.CY,
    locale: Locales.enGb,
    hreflang: 'en-CY',
  },
  'en-cz': {
    prefix: 'en-cz',
    country: Countries.CZ,
    locale: Locales.enGb,
    hreflang: 'en-CZ',
  },
  de: {
    prefix: 'de',
    country: Countries.DE,
    locale: Locales.deDe,
    hreflang: 'de-DE',
  },
  'en-de': {
    prefix: 'en-de',
    country: Countries.DE,
    locale: Locales.enGb,
    hreflang: 'en-DE',
  },
  'en-dk': {
    prefix: 'en-dk',
    country: Countries.DK,
    locale: Locales.enGb,
    hreflang: 'en-DK',
  },
  'en-ee': {
    prefix: 'en-ee',
    country: Countries.EE,
    locale: Locales.enGb,
    hreflang: 'en-EE',
  },
  es: {
    prefix: 'es',
    country: Countries.ES,
    locale: Locales.esEs,
    hreflang: 'es-ES',
  },
  'en-es': {
    prefix: 'en-es',
    country: Countries.ES,
    locale: Locales.enGb,
    hreflang: 'en-ES',
  },
  'en-fi': {
    prefix: 'en-fi',
    country: Countries.FI,
    locale: Locales.enGb,
    hreflang: 'en-FI',
  },
  'sv-fi': {
    prefix: 'sv-fi',
    country: Countries.FI,
    locale: Locales.svSe,
    hreflang: 'sv-FI',
  },
  fr: {
    prefix: 'fr',
    country: Countries.FR,
    locale: Locales.frFr,
    hreflang: 'fr-FR',
  },
  'en-fr': {
    prefix: 'en-fr',
    country: Countries.FR,
    locale: Locales.enGb,
    hreflang: 'en-FR',
  },
  gb: {
    prefix: 'gb',
    country: Countries.GB,
    locale: Locales.enGb,
    hreflang: 'en-GB',
  },
  'en-gi': {
    prefix: 'en-gi',
    country: Countries.GI,
    locale: Locales.enGb,
    hreflang: 'en-GI',
  },
  'en-gr': {
    prefix: 'en-gr',
    country: Countries.GR,
    locale: Locales.enGb,
    hreflang: 'en-GR',
  },
  'en-hk': {
    prefix: 'en-hk',
    country: Countries.HK,
    locale: Locales.enGb,
    hreflang: 'en-HK',
  },
  'zh-hk': {
    prefix: 'zh-hk',
    country: Countries.HK,
    locale: Locales.zhHans,
    hreflang: 'zh-HK',
  },
  'en-hr': {
    prefix: 'en-hr',
    country: Countries.HR,
    locale: Locales.enGb,
    hreflang: 'en-HR',
  },
  'it-hr': {
    prefix: 'it-hr',
    country: Countries.HR,
    locale: Locales.itIt,
    hreflang: 'it-HR',
  },
  'en-hu': {
    prefix: 'en-hu',
    country: Countries.HU,
    locale: Locales.enGb,
    hreflang: 'en-HU',
  },
  ie: {
    prefix: 'ie',
    country: Countries.IE,
    locale: Locales.enGb,
    hreflang: 'en-IE',
  },
  in: {
    prefix: 'in',
    country: Countries.IN,
    locale: Locales.enGb,
    hreflang: 'en-IN',
  },
  it: {
    prefix: 'it',
    country: Countries.IT,
    locale: Locales.itIt,
    hreflang: 'it-IT',
  },
  'en-it': {
    prefix: 'en-it',
    country: Countries.IT,
    locale: Locales.enGb,
    hreflang: 'en-IT',
  },
  jp: {
    prefix: 'jp',
    country: Countries.JP,
    locale: Locales.jaJp,
    hreflang: 'ja-JP',
  },
  'en-jp': {
    prefix: 'en-jp',
    country: Countries.JP,
    locale: Locales.enUs,
    hreflang: 'en-JP',
  },
  'de-li': {
    prefix: 'de-li',
    country: Countries.LI,
    locale: Locales.deDe,
    hreflang: 'de-LI',
  },
  'en-li': {
    prefix: 'en-li',
    country: Countries.LI,
    locale: Locales.enGb,
    hreflang: 'en-LI',
  },
  'en-lt': {
    prefix: 'en-lt',
    country: Countries.LT,
    locale: Locales.enGb,
    hreflang: 'en-LT',
  },
  'fr-lu': {
    prefix: 'fr-lu',
    country: Countries.LU,
    locale: Locales.frFr,
    hreflang: 'fr-LU',
  },
  'de-lu': {
    prefix: 'de-lu',
    country: Countries.LU,
    locale: Locales.deDe,
    hreflang: 'de-LU',
  },
  'en-lu': {
    prefix: 'en-lu',
    country: Countries.LU,
    locale: Locales.enGb,
    hreflang: 'en-LU',
  },
  'en-lv': {
    prefix: 'en-lv',
    country: Countries.LV,
    locale: Locales.enGb,
    hreflang: 'en-LV',
  },
  'en-my': {
    prefix: 'en-my',
    country: Countries.MY,
    locale: Locales.enGb,
    hreflang: 'en-MY',
  },
  'zh-my': {
    prefix: 'zh-my',
    country: Countries.MY,
    locale: Locales.zhHans,
    hreflang: 'zh-MY',
  },
  'en-mt': {
    prefix: 'en-mt',
    country: Countries.MT,
    locale: Locales.enGb,
    hreflang: 'en-MT',
  },
  mx: {
    prefix: 'mx',
    country: Countries.MX,
    locale: Locales.es419,
    hreflang: 'es-MX',
  },
  'en-mx': {
    prefix: 'en-mx',
    country: Countries.MX,
    locale: Locales.enUs,
    hreflang: 'en-MX',
  },
  nl: {
    prefix: 'nl',
    country: Countries.NL,
    locale: Locales.nlNl,
    hreflang: 'nl-NL',
  },
  'en-nl': {
    prefix: 'en-nl',
    country: Countries.NL,
    locale: Locales.enGb,
    hreflang: 'en-NL',
  },
  'en-no': {
    prefix: 'en-no',
    country: Countries.NO,
    locale: Locales.enGb,
    hreflang: 'en-NO',
  },
  nz: {
    prefix: 'nz',
    country: Countries.NZ,
    locale: Locales.enGb,
    hreflang: 'en-NZ',
  },
  'en-pl': {
    prefix: 'en-pl',
    country: Countries.PL,
    locale: Locales.enGb,
    hreflang: 'en-PL',
  },
  'pt-pt': {
    prefix: 'pt-pt',
    country: Countries.PT,
    locale: Locales.ptBr,
    hreflang: 'pt-PT',
  },
  'en-pt': {
    prefix: 'en-pt',
    country: Countries.PT,
    locale: Locales.enGb,
    hreflang: 'en-PT',
  },
  'en-ro': {
    prefix: 'en-ro',
    country: Countries.RO,
    locale: Locales.enGb,
    hreflang: 'en-RO',
  },
  se: {
    prefix: 'se',
    country: Countries.SE,
    locale: Locales.svSe,
    hreflang: 'sv-SE',
  },
  'en-se': {
    prefix: 'en-se',
    country: Countries.SE,
    locale: Locales.enGb,
    hreflang: 'en-SE',
  },
  'en-sg': {
    prefix: 'en-sg',
    country: Countries.SG,
    locale: Locales.enGb,
    hreflang: 'en-SG',
  },
  'zh-sg': {
    prefix: 'zh-sg',
    country: Countries.SG,
    locale: Locales.zhHans,
    hreflang: 'zh-SG',
  },
  'en-si': {
    prefix: 'en-si',
    country: Countries.SI,
    locale: Locales.enGb,
    hreflang: 'en-SI',
  },
  'it-si': {
    prefix: 'it-si',
    country: Countries.SI,
    locale: Locales.itIt,
    hreflang: 'it-SI',
  },
  'en-sk': {
    prefix: 'en-sk',
    country: Countries.SK,
    locale: Locales.enGb,
    hreflang: 'en-SK',
  },
  th: {
    prefix: 'th',
    country: Countries.TH,
    locale: Locales.thTh,
    hreflang: 'th-TH',
  },
  'en-th': {
    prefix: 'en-th',
    country: Countries.TH,
    locale: Locales.enGb,
    hreflang: 'en-TH',
  },
} as const;
